export { default } from './FaIcon.jsx';
